<template lang="pug">
div
  el-divider 指定选择目录
  el-form-item(key="root", label="项目目录限制")
    el-dropdown(@command="commandOfDir")
      el-input(:value="prjRootObj.folderStr", size="mini", readonly)
      template(#dropdown)
        el-dropdown-menu
          el-dropdown-item(icon="el-icon-edit", :command="openRootDoc") 编辑
          el-dropdown-item(icon="el-icon-delete", :command="clearRootDirectory") 清空
</template>
<script>
import ModuleFolder from "../upload/moduleFolder/index.vue";
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import asyncCom from "@/CommonDP/commons/asyncCom";
import { last } from 'lodash-es';
export default {
  mixins: [settingMixin],
  data() {
    return { list: [] };
  },
  computed: {
    ...mapVFOptions("prjRoot", "prjRootName", "prjRootModule"),
    prjRootObj() {
      const { prjRoot = "", prjRootName, prjRootModule } = this;
      return {
        folderId: prjRoot,
        moduleId: prjRootModule,
        folderStr: prjRootName || prjRoot
      };
    }
  },
  methods: {
    commandOfDir(fn) {
      return fn.call(this);
    },
    async openRootDoc() {
      const { prjRoot, prjRootModule } = this;
      const obj = { defaultIds: prjRoot ? [prjRoot] : [], moduleId: prjRootModule };
      const { paths } = await this.openDoc(obj);
      const folder = last(paths);
      if (!folder) return this.clearRootDirectory();
      this.prjRoot = folder.folderId;
      this.prjRootModule = folder.moduleId;
      this.prjRootName = paths.map(({ folderName }) => folderName).join("/");
    },
    clearRootDirectory() {
      this.prjRoot = "";
      this.prjRootModule = "";
      this.prjRootName = "";
    },
    async openDoc(data) {
      return asyncCom(ModuleFolder, data);
    }
  }
};
</script>
